<template>
  <b-container class="principal_lti_container" fluid>
    <div>
      <b-tabs content-class="mt-3">
        <b-tab :title="$t('reviews.list')" active>
          <Revisiones />
        </b-tab>
      </b-tabs>
    </div>
    <!-- Tabs navs -->
  </b-container>
</template>

<script>
import Revisiones from "@/components/Lti/Revisiones";
import jwtMixin from "@/mixins/jwtMixin";
import { debounce } from "vue-debounce";
import useUserState from "@/store/userState";
import useCourseState from "@/store/courseState";
import useGroupState from "@/store/groupState";

export default {
  name: "LtiContainer",
  mixins: [jwtMixin],
  components: {
    /*LtiSidebar*/
    Revisiones,
  },
  data() {
    return {
      sidebarCollapsed: true,
      userStore: useUserState(),
      courseState: useCourseState(),
      groupStore: useGroupState(),
    };
  },
  created() {
    this.setCssVariables();
    window.addEventListener("resize", debounce(this.setCssVariables, 300));
  },
  beforeMount() {
    this.userStore.setUser({
      id: this.jwtLoggedUserId(),
      name: this.jwtGetUserName(),
      userRole: this.jwtLoggedUserRole(),
      email: this.jwtEmail(),
      unirId: this.jwtUnirId(),
    });

    this.courseState.title = this.jwtContextTitle();
    this.courseState.licenceId = this.jwtConsumerId();
    this.courseState.site = this.jwtContextSite();
    this.groupStore.getUserGroups();
  },
  methods: {
    getDimensions() {
      return {
        width: 0.01 * window.innerWidth,
        height: 0.01 * window.innerHeight,
      };
    },
    setCssVariables() {
      let dimensions = this.getDimensions();
      let width = dimensions.width;
      let height = dimensions.height - 0.56;
      document.documentElement.style.setProperty("--vw", width + "px");
      document.documentElement.style.setProperty("--vh", height + "px");
      document.documentElement.style.setProperty(
        "--lti-primary-color",
        this.jwtPrimaryColor()
      );
      document.documentElement.style.setProperty(
        "--lti-secondary-color",
        this.jwtSecondaryColor()
      );
      document.body.style.setProperty("font-family", this.jwtFont());
    },
    onToggleCollapse(collapsed) {
      this.sidebarCollapsed = collapsed;
    },
  },
};
</script>
